import React from "react";
import { Neo } from "@singularsystems/neo-react";
import { List, Misc, Model, NumberUtils } from "@singularsystems/neo-core";
import { AppService, DomainTypes } from "../DomainTypes";
import IssuerInvestmentLookup from "../Models/IssuerInvestments/Lookups/IssuerInvestmentLookup";
import { observer } from "mobx-react";
import { isHidden } from "../Models/Config/FieldConfig/FieldSetting.enum";

interface IIssuerInvestmentAutoCompleteProps {
    bind: Model.IPropertyInstance<number | null>;
    bindDisplay: Model.IPropertyInstance<string | null>;
    entityId?: number | null;
    productTypeId?: number | null;
    onItemSelected?: (item?: Model.PlainObject<IssuerInvestmentLookup>) => void;
    /**
     * Set to true if the drop down will be used to select a parent investment (If HasVestingTrust is true on the entity).
     */
    useParentCache: boolean;
}

@observer
export default class IssuerInvestmentAutoComplete extends React.Component<IIssuerInvestmentAutoCompleteProps> {

    constructor(props: IIssuerInvestmentAutoCompleteProps) {
        super(props);

        this.onMenuOpen = this.onMenuOpen.bind(this);
    }

    private issuerInvestmentApiClient = AppService.get(DomainTypes.ApiClients.IssuerInvestment);
    private issuerInvestmentCache = AppService.get(DomainTypes.Services.IssuerInvestmentCache);
    private dataCache = AppService.get(DomainTypes.Services.DataCache);

    private onMenuOpen() {
        if (this.props.useParentCache) {
            this.issuerInvestmentCache.updateParentInvestments();
        }
    }

    public render() {
        const { bind, bindDisplay, entityId, productTypeId, onItemSelected, useParentCache } = this.props;
        const fieldSettings = this.dataCache.fieldConfig.issuerInvestmentFields;
        const hasDefaultInvestments = useParentCache && this.issuerInvestmentCache.parentIssuerInvestments.length > 0;
        const investmentNameIsHidden = isHidden(fieldSettings.investmentName);

        let filteredInvestments: IssuerInvestmentLookup[] = this.issuerInvestmentCache.parentIssuerInvestments;

        if (entityId) {
            filteredInvestments = filteredInvestments.filter(c => c.entityId === entityId);
        }
        if (productTypeId) {
            filteredInvestments = filteredInvestments.filter(c => c.productTypeId === productTypeId);
        }

        return <Neo.AutoCompleteDropDown
            bind={bind}
            bindDisplay={bindDisplay}
            itemSource={async st => List.fromJSArray(IssuerInvestmentLookup, (await this.issuerInvestmentApiClient.getIssuerInvestmentLookups(st, entityId ?? null, productTypeId ?? null)).data)}
            items={hasDefaultInvestments ? filteredInvestments : undefined}
            displayMember="idAndIssuerName"
            onItemSelected={onItemSelected}
            onMenuOpen={this.onMenuOpen}
            option={(item: Model.PlainObject<IssuerInvestmentLookup>) => <>
                <div style={item.investmentName && !investmentNameIsHidden ? { flexBasis: 25, flexShrink: 0 } : { flexBasis: 25, flexShrink: 0 }}>{item.issuerInvestmentId}</div>
                {item.investmentName && !investmentNameIsHidden && <div style={{ flexBasis: 200, flexShrink: 0 }}>{item.investmentName}</div>}
                <div style={ item.investmentName && !investmentNameIsHidden ? { flexBasis: 200, flexShrink: 0 } : { flexGrow: 1 }}>{item.issuerName}</div>
                <div style={{ textAlign: "right" }}>
                    {NumberUtils.format(item.currentBalance, Misc.NumberFormat.CurrencyNoDecimals, "R")}
                </div>
            </>
            }
        />
    }
}